<template>
  <div id="new_password" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <div class="title">
            <h2>パスワードの更新</h2>
          </div>
          <dd-password-input
            ref="passwordInput"
            :passwordForm="passwordForm"
          />
          <div class="control_btn_area">
            <div class="main_btn sel_sub_btn" @click="cancel()">
              <a>戻る</a>
            </div>
            <div class="main_btn sel_main_btn" @click="update()">
              <a>更新する</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import PasswordInput from '../components/user/DcPasswordInput'
import {DC_URL} from '../../constants/App'

export default {
  name: 'UpdatePasswordInput',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-password-input': PasswordInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'dcUpdatePasseord',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'updatePassword', key: 'dcUpdatePasseord', title: 'パスワード更新'}
      ],
      passwordForm: {
        password: '',
        confirmPassword: ''
      },
      errors: {}
    }
  },
  computed: {
  },
  methods: {
    cancel: function () {
      this.$router.go(-1)
    },
    update: function () {
      let ret = this.$refs.passwordInput.confirm()
      if (!ret) return

      // DBに登録する
      let payload = {
        password: this.passwordForm.password,
        confirmPassword: this.passwordForm.confirmPassword
      }
      axios.post(DC_URL.USER + '/update-password', payload
      ).then(response => {
        if (response.data.errorMessage) {
        //   this.fieldErrorMessages.password = response.data.errorMessage
        //   this.$refs.passwordInput.setErrorMessage(this.fieldErrorMessages)
        } else {
          this.$router.go(-1)
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcUpdatePasswordInput.vue